import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {
    TrainingAndCertificationSubmit,
    TrainingAndCertificationVerbose
} from '@app/modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-details/components/training-and-certifications/models/training-and-certification.model';
import { catchError, map } from 'rxjs/operators';
import { api_routes } from '@app/consts';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class TrainingAndCertificationService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getTrainingAndCertifications(employeeId: string, take?: number, skip?: number, sort?: string): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;
    sort ? params = params.append('sort', sort) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.TRAINING_AND_CERTIFICATIONS}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deleteTrainingAndCertification(employeeId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.TRAINING_AND_CERTIFICATIONS}/${id}`, {
      headers: headers
    });
  }

  getTrainingAndCertification(employeeId: string, id: string): Observable<TrainingAndCertificationVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.TRAINING_AND_CERTIFICATIONS}/${id}`, {
      headers: headers
    });
  }

  updateTrainingAndCertification(employeeId: string, trainingAndCertificationTest: TrainingAndCertificationSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.TRAINING_AND_CERTIFICATIONS}/${trainingAndCertificationTest.id}`, trainingAndCertificationTest, {
      headers: headers
    });
  }

  createTrainingAndCertification(employeeId: string, trainingAndCertificationTest: TrainingAndCertificationSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.TRAINING_AND_CERTIFICATIONS}`, trainingAndCertificationTest, {
      headers: headers
    });
  }
}
